<template>
  <div id="app">
	<Title></Title>
	
	<Content></Content>
	
	<Footer></Footer>
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Title from './web/Title.vue'
import Content from "./web/Content.vue"
import Footer from "./web/Footer.vue"
import "./assets/css/index.css"
import "./assets/css/style.css"

export default {
  name: 'app',
  components: {
    HelloWorld,Title,Content,Footer
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
body{
	background-image: url("http://www.ewway.com/images/pic/banner.jpg");
}
</style>
